// extracted by mini-css-extract-plugin
export default {"selectWrap":"selectWrap-XTqzSQ","title":"title-GKFPay"};